import { api } from '../api/client'
import { useQuery } from '../api/hooks'
import { ExternalLink } from '../components/ui/ExternalLink'
import { Panel } from '../components/ui/Panel'
import { EmptyState, QueryView } from '../components/ui/States'
import { X_HANDLE, LINKS } from '../config'
import { fmtTime } from '../lib/format'

// Standalone X-posts page. This is the former admin PostsPanel, promoted to
// its own route while agent-management UX is still being designed; the rest
// of pages/Admin.tsx is intentionally kept (unrouted) for that future work.
export function XPosts() {
  return (
    <div className="space-y-6">
      <PostsPanel />
    </div>
  )
}

export function PostsPanel() {
  const posts = useQuery(() => api.posts())
  return (
    <Panel title={`x posts // ${X_HANDLE}`}>
      <p className="text-xs text-crt-dim">
        Published posts as served by the public API (only status=posted rows;
        the gateway does not expose the pending queue). Live feed:{' '}
        <ExternalLink href={LINKS.xProfile}>{X_HANDLE}</ExternalLink>
      </p>
      <QueryView state={posts.state} onRetry={posts.refresh}>
        {(p) =>
          p.items.length === 0 ? (
            <EmptyState
              title="no posts yet"
              detail={`Nothing published yet. Trade and rebalance summaries appear here once posted to ${X_HANDLE}.`}
            />
          ) : (
            <div className="mt-2">
              <table className="w-full table-fixed text-sm">
                <thead>
                  <tr>
                    <th className="th w-14">link</th>
                    <th className="th w-36">posted</th>
                    <th className="th">content</th>
                  </tr>
                </thead>
                <tbody>
                  {p.items.map((post) => (
                    <tr key={post.id} className="align-top hover:bg-crt-panel2">
                      <td className="td">
                        {post.xPostId ? (
                          <ExternalLink
                            href={`https://x.com/AgenticStonker/status/${post.xPostId}`}
                          >
                            open
                          </ExternalLink>
                        ) : (
                          <span className="text-crt-dim">—</span>
                        )}
                      </td>
                      <td className="td whitespace-nowrap text-xs text-crt-dim">
                        {fmtTime(post.postedAt)}
                      </td>
                      <td className="td">
                        <span className="line-clamp-3 text-xs">
                          {post.content}
                        </span>
                        <span className="mt-1 block truncate text-[10px] text-crt-dim">
                          {post.refType}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
        }
      </QueryView>
    </Panel>
  )
}
